import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Consultas do paciente, com cache de leitura offline (via useCachedQuery).
export function usePatientAppointments(patientId) {
  const url = patientId ? `/appointments/patients/${patientId}` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    appointments: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
